/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

$(function() {
 var referrer = document.referrer;
 var domain = document.domain;
  if(referrer.match(domain)) { //サイト内回遊
    if( localStorage.getItem('akarazbnr') != 1) {
      $('.head-right-banner').show();
    }
  } else {
      localStorage.removeItem('akarazbnr');
      $('.head-right-banner').show();
  }
  
  
  var swiper = new Swiper(".mySwiper", {
      loop: true,
      spaceBetween: 10,
      slidesPerView: 2.8,
      freeMode: true,
      watchSlidesProgress: true,
        breakpoints: {
        1000: { 
          slidesPerView: 4,
        }
      },
    pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
      },
    });
    var swiper2 = new Swiper(".mySwiper2", {
      loop: true,
      spaceBetween: 10,
        effect: 'slide',
        breakpoints: {
        1000: {
          slidesPerView: 1.5,
          spaceBetween: 16,
          centeredSlides: true
        }
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      }
    });
    $('.head-right-banner .close').click(function() {
      $('.head-right-banner').hide();
      localStorage.setItem('akarazbnr', 1);
    });

  $('.product-block-list__item .card__section:visible').each(function(index, elm) {
   $(this).parents('.product-block-list__item').find('.card__header').addClass('open');
});

$('.product-block-list__item--content .card__header, .product-block-list__item--description .card__header').click(function() {
  $(this).toggleClass('open');
  if($(this).hasClass('open')) {
    $(this).next('.card__section').slideDown();
  } else {
    $(this).next('.card__section').slideUp();
  }
});
  
  $('.accordion-conts__title').click(function() {
    var parent = $(this).parents('.accordion-conts');
    parent.toggleClass('open');
    if(parent.hasClass('open')) {
      parent.find('.accordion-conts__conts').slideDown();
    } else  {
      parent.find('.accordion-conts__conts').slideUp();
    }
  });
$('.accordion-conts').each(function(index, elm) {
  if($(elm).hasClass('open')) {
    $(this).find('.accordion-conts__conts').show();
  }
});

  
  /*
  const swiper = new Swiper('.swiper', {
  // Optional parameters
  loop: true,
    effect: 'slide',
    breakpoints: {
    1000: {
      slidesPerView: 1.5,
      spaceBetween: 16,
      centeredSlides: true
    }
  },
    

  // Navigation arrows
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
pagination: {
    el: '.swiper-pagination',
    type: 'bullets',
  },
});
  */
});
